<template>
    <v-container fluid class="container-full-bg-gray">

        <v-dialog v-model="delete_dialog" max-width="290">
            <v-card>
                <v-card-title class="headline">Seguro que quieres eliminar este Guideline?</v-card-title>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="blue darken-1" text @click="delete_dialog = false">Cancelar</v-btn>
                    <v-btn color="blue darken-1" text @click="deleteGuideline">OK</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-card>
            <!-- {{this.screen_data.guideline}}
                    aaaa
                {{ this.screen_data.condition_options }} -->
                
            <v-row>
                <v-col cols="10">
                    <div class="mr-auto d-flex align-sm-center">
                        <v-btn icon @click="$router.push({name: 'guidelines-list'})">
                            <AppIcon :src="require('../assets/back-arrow.svg')" :size="29" />
                        </v-btn>
                    </div>  
                    <v-card-title>
                        {{ screen_data.guideline.id ? 'Edit Guideline' : 'New Guideline' }} {{ screen_data.guideline.id ? screen_data.guideline.id : ''}}
                    </v-card-title>
                </v-col>
                <v-col cols="2">
                    <v-btn
                        @click="saveGuideline"
                        color="primary"
                        :disabled="!allowSave"
                        :loading="screen_data.loading"
                    >
                        Guardar
                    </v-btn>
                    <v-btn
                        @click="delete_dialog = true"
                        color="red"
                        :disabled="untouchable || !screen_data.guideline.id || !deletable"
                        :loading="screen_data.loading"
                    >
                        BORRAR
                    </v-btn>
                </v-col>
                
            </v-row>
            
            <v-row v-if="untouchable">
                <v-col>
                    <v-alert
                        type="error"
                        outlined
                    >
                        <v-row>
                            <v-col>
                                <span>Este guideline no es editable ya que tiene configuraciones todavía no soportadas en frontend</span>
                            </v-col>
                        </v-row>
                    </v-alert>
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="2">
                    <v-autocomplete 
                        label="Usuario"
                        v-model="screen_data.guideline.user_id"
                        :items="c_users"
                        item-value="id"
                        item-text="username"
                        autocomplete="off"
                        outlined
                        :disabled="Boolean(screen_data.guideline.company_id) || untouchable"
                    ></v-autocomplete>
                </v-col>
                <v-col cols="2">
                    <v-text-field
                        v-model="screen_data.guideline.company_id"
                        label="Company ID"
                        outlined
                        :disabled="Boolean(screen_data.guideline.user_id) || untouchable"
                    ></v-text-field>
                </v-col>
                <v-col cols="2">
                    <v-autocomplete
                        v-model="screen_data.guideline.params.when"
                        :items="[{name: 'Después de detección', value: 'data_detection'},{name: 'Antes de detección', value: 'pre_data_detection'}, {name: 'Después de validación', value: 'format_data'}, {name: 'Después de validación de asiento', value: 'validate_move'}]"
                        label="When"
                        outlined
                        item-text="name"
                        item-value="value"
                        :disabled="untouchable"
                    ></v-autocomplete>
                </v-col>
                <v-col cols="3">
                    <v-autocomplete
                        v-model="screen_data.guideline.condition"
                        :items="screen_data.condition_options"
                        label="Condition"
                        outlined
                        item-text="name"
                        item-value="func_name"
                        @change="conditionChanged"
                        :disabled="untouchable"
                    ></v-autocomplete>
                </v-col>
                <v-col cols="3">
                    <v-autocomplete
                        v-model="screen_data.guideline.consequence"
                        :items="screen_data.consequence_options"
                        label="Consequence"
                        outlined
                        item-text="name"
                        item-value="func_name"
                        @change="consequenceChanged"
                        :disabled="untouchable"
                    ></v-autocomplete>
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="2">
                    <v-card-text class="px-0 pt-0 card-title-footer-color" style="color:gray; margin-top:-40px">
                       ( {{ screen_data.guideline.username }} )
                    </v-card-text>
                    <template v-if="screen_data.guideline.user_id">
                        <v-card-text class="px-0 pt-0 card-title-footer-color" style="color:gray; margin-top:-40px">
                            <v-btn @click="screen_data.guideline.user_id = null" icon>
                                <v-icon>mdi-close</v-icon>
                            </v-btn>
                        </v-card-text>
                    </template>
                </v-col>
                <v-col cols="2">
                    <v-card-text class="px-0 pt-0 card-title-footer-color" style="color:gray; margin-top:-40px">
                       ( {{ screen_data.guideline.company_name }} )
                    </v-card-text>
                </v-col>
                <v-col cols="2">
                    <v-card-text class="px-0 pt-0 card-title-footer-color" style="color:gray; margin-top:-40px">
                       ( {{ screen_data.guideline.params.when }} )
                    </v-card-text>
                </v-col>
                <v-col cols="3">
                    <v-card-text class="px-0 pt-0 card-title-footer-color" style="color:gray; margin-top:-40px">
                       ( {{ screen_data.guideline.condition }} )
                    </v-card-text>
                </v-col>
                <v-col cols="3">
                    <v-card-text class="px-0 pt-0 card-title-footer-color" style="color:gray; margin-top:-40px">
                        ( {{ screen_data.guideline.consequence }} )
                    </v-card-text>
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="6">
                    <v-row>
                        <v-col cols="12">
                            <v-text-field
                                v-model="screen_data.guideline.description"
                                label="Descripción breve"
                                outlined
                                :disabled="untouchable"
                            ></v-text-field>
                        </v-col>
                    </v-row>
                </v-col>
                <v-col cols="3">
                    <RecursivePayloadOnSchemaEditor  v-if="show_condition_params"
                    :schema="current_condition.params_schema" 
                    :key_to_show="'Parámetros de condición'"
                    v-model="screen_data.guideline.params.condition" />
                </v-col>
                <v-col cols="3">
                    <RecursivePayloadOnSchemaEditor v-if="show_consequence_params"
                    :schema="current_consequence.params_schema" 
                    :key_to_show="'Parámetros de consecuencia'"
                    v-model="screen_data.guideline.params.consequence" />
                    
                </v-col> 
            </v-row>
            <v-row>
                <v-col cols="6">
                    
                </v-col>
                <v-col cols="3" >
                    <p class="text--italic text--grey" v-if="current_condition && current_condition.description">{{current_condition.description}}</p>
                </v-col>
                <v-col cols="3" >
                    <p class="text--italic text--grey" v-if="current_consequence && current_consequence.description">{{current_consequence.description}}</p>
                </v-col>
            </v-row>
            <v-row v-if="this.screen_data.execution_stats">
                <v-card-title>
                    Estadísticas desde el último guardado:  &nbsp &nbsp
                    <span class="text--italic text--grey"> (no todos los guidelines miden los éxitos)</span>
                </v-card-title>
            </v-row>
            <v-row v-if="this.screen_data.execution_stats">
                <v-col cols="2">
                    <v-row>
                        <v-col cols="12">
                            <v-card-text class="px-0 pt-0 card-title-footer-color">
                                <span class="text--grey">Ejecuciones: &nbsp</span> 
                                <span class="text--primary">{{ this.screen_data.execution_stats.executions }}</span>
                            </v-card-text>
                        </v-col>
                    </v-row>
                </v-col>
                <v-col cols="2">
                    <v-row>
                        <v-col cols="12">
                            <v-card-text class="px-0 pt-0 card-title-footer-color">
                                <span class="text--grey">Condición válida: &nbsp</span> 
                                <span class="text--primary">{{ this.screen_data.execution_stats.condition_passed }}</span>
                            </v-card-text>
                        </v-col>
                    </v-row>
                </v-col>
                <v-col cols="2">
                    <v-row>
                        <v-col cols="12">
                            <v-card-text class="px-0 pt-0 card-title-footer-color">
                                <span class="text--grey">Consecuencia exitosa: &nbsp</span> 
                                <span class="text--primary">{{ this.screen_data.execution_stats.consequence_success }}</span>
                            </v-card-text>
                        </v-col>
                    </v-row>
                </v-col>
                <v-col cols="6">
                    <v-row>
                        <v-col cols="12">
                            <v-card-text class="px-0 pt-0 card-title-footer-color">
                                <span class="text--grey">Extra info: &nbsp</span> 
                                <span class="text--primary">{{ this.screen_data.execution_stats.computed_data }}</span>
                            </v-card-text>
                        </v-col>
                    </v-row>
                </v-col>
            </v-row>
            <v-divider> </v-divider>
            <v-row>
                <v-col cols="12"> <div style="color:gray">{{ this.screen_data.guideline }}</div></v-col>
               
                
            </v-row>
        </v-card>
    </v-container>
</template>

<script>
import { VueGuidelineDetailScreenData } from "@/modules/guidelines/infra/VueGuidelinesScreenData";
import { GuidelineDetailComponent } from "@/modules/guidelines/app/GuidelineDetailComponent";
import { GuidelinesApiRepo } from "@/modules/guidelines/infra/GuidelinesAPIRepo";
import { client } from "@/api/client";
import RecursivePayloadOnSchemaEditor from "@/modules/entities/infra/RecursivePayloadOnSchemaEditor.vue";
import { mapState } from 'vuex';
export default {
    name: "GuidelineEditor",
    components: {
        RecursivePayloadOnSchemaEditor
    },
    props: {
        guideline_id: {
            type: [String, Number],
            required: false
        }
    },
    data() {
        const screen_data = new VueGuidelineDetailScreenData();
        return {
            screen_data:screen_data,
            guideline_editor_component:null,
            delete_dialog: false,
            users: [],
        };
    },
    async mounted() {
        let guideline_repo = new GuidelinesApiRepo();
        this.guideline_editor_component = new GuidelineDetailComponent(guideline_repo, this.screen_data)
        this.get_users()
        await this.fetchOptions();
        if (this.guideline_id) {
            await this.fetchGuideline(this.guideline_id);
            await this.guideline_editor_component.getGuidelineStats();
        }
    },
    methods: {
        async refreshGuideline() {
            await this.guideline_editor_component.refreshGuideline();
        },
        async fetchGuideline(guideline_id) {
            await this.guideline_editor_component.fetchGuideline(guideline_id);
        },
        async fetchOptions() {
            await this.guideline_editor_component.fetchOptions();
        },
        async saveGuideline() {
            await this.guideline_editor_component.saveGuideline();
            this.$router.replace({ name: 'guideline-editor', params: {'guideline_id': this.screen_data.guideline.id } });
        },
        parseValue(param) {
            let value = this.screen_data.guideline.params.consequence[param.field];
            if (param.type === 'int') {
                value = parseInt(value, 10);
            } else if (param.type === 'float') {
                value = parseFloat(value);
            }

            this.screen_data.guideline.params.consequence[param.field] = value;
        },
        conditionChanged() {
            this.screen_data.guideline.params.condition = {};
        },
        consequenceChanged() {
            console.log('consequence changed')
            this.screen_data.guideline.params.consequence = {};
        },
        deleteGuideline() {
            let deleted = this.guideline_editor_component.deleteGuideline();
            if (deleted) {
                this.$router.push({ name: 'guidelines-list' });
            }
            else{
                this.delete_dialog = false
                console.log('error deleting guideline')
            }
        },
        get_users() {
            let session_username = this.session_information.username;
            client.get('get_users_to_loginas/', { params:{ 'session_username': session_username}}).then(response => {
                this.users = response.data;
            }).catch(err => {
                console.debug(err);
            });
            
        },
    },
    computed: {
        untouchable() {
            let condition = this.screen_data.guideline.condition;
            let consequence = this.screen_data.guideline.consequence;
            let cond_ops = this.screen_data.condition_options;
            let cons_ops = this.screen_data.consequence_options;
            if(condition && consequence){
                //if condition or consequence not in options this guideline is untouchable
                if(cond_ops.findIndex((item) => item.func_name === condition) === -1){
                    return true
                }
                if(cons_ops.findIndex((item) => item.func_name === consequence) === -1){
                    return true
                }
            }
            return false
        },
        deletable() {
            return this.screen_data.execution_stats && this.screen_data.execution_stats.executions === 0
        },
        show_condition_params(){
            return this.current_condition && this.current_condition.params_schema && Object.keys(this.current_condition.params_schema).length > 0 && this.current_condition.params_schema.properties && Object.keys(this.current_condition.params_schema.properties).length > 0
        },
        show_consequence_params(){
            return this.current_consequence && this.current_consequence.params_schema && Object.keys(this.current_consequence.params_schema).length > 0 && this.current_consequence.params_schema.properties && Object.keys(this.current_consequence.params_schema.properties).length > 0
        },
        current_condition(){
            //have to find the template in options 
            let condition = this.screen_data.guideline.condition;
            let cond_ops = this.screen_data.condition_options;
            let index = cond_ops.findIndex((item) => item.func_name === condition);
            if(index !== -1){
                return cond_ops[index]
            }
            return null
        },
        current_consequence(){
            //have to find the template in options 
            let consequence = this.screen_data.guideline.consequence;
            let cons_ops = this.screen_data.consequence_options;
            let index = cons_ops.findIndex((item) => item.func_name === consequence);
            if(index !== -1){
                return cons_ops[index]
            }
            return null
        },
        allowSave(){
            return ((this.screen_data.guideline.user_id || this.screen_data.guideline.company_id) && this.screen_data.guideline.condition && this.screen_data.guideline.consequence) && !this.untouchable
        },
        c_users(){
            let extra_users = [{id: 2237, username: 'support.narcis'}]
            return this.users.concat(extra_users)
        },
        ...mapState(['session_information']),
    },

};

</script>

<style scoped>
.text--italic {
    font-style: italic;
    font-size: 17px;
}

.text--grey {
    color: gray;
}

.text--primary {
    color: black; /* or any other color of your choice */
}
</style>